import React from "react";
import { Divider } from "@mui/material";

export default function Module_1() {
    return (
        <>
            <div className="full-width bg-white py-4">
                <div className="m-auto mw-900">
                    <div className="container">
                        <Divider>
                            <h2 className="py-4 text-muted text-uppercase text-center fs-1">
                                We deliver{" "}
                                <span className="text-decoration-underline text-underline-offset">
                                    value
                                </span>
                            </h2>
                        </Divider>
                        <p>
                            In our goal to exceed expectations, we always strive
                            to do more for the customer. From product selection
                            to shop drawings and design adjustments, all the way
                            to shipping and after-sales, our promise to do more
                            translates into agile and responsive customer
                            service.
                        </p>
                        <p>
                            But our commitment to value goes beyond the realm of
                            customer support. When DSSL designed its first
                            retrofit kits, there was a strong desire to
                            outperform similar products. We achieved that
                            objective by posting excellent results, thereby
                            developing the most efficient kits on the market.
                        </p>
                        <p>
                            We also go out of our way to provide affordably
                            priced custom designs. This strategy has helped DSSL
                            establish a strong market position for its
                            customizing capabilities. Further, DSSL will seek to
                            leverage its promise of superior value in an effort
                            to expand its line of specification grade products,
                            with an emphasis on cost-effective high-performance
                            lighting.
                        </p>
                        <p>
                            In addition, we remain firmly committed to
                            manufacturing reliable products with some of the
                            lowest failure rates in the industry, while meeting
                            the most stringent standards in terms of
                            performance, energy savings and lighting quality.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}
